import React, {useState,useEffect} from 'react'
import { Bar } from 'react-chartjs-2';
import { ToggleButton,Box,ToggleButtonGroup, Typography } from '@mui/material';
import useAxiosPrivate from '../hooks/useAxiosPrivate';
import { Chart } from "chart.js";
import { registerables} from 'chart.js';
import { Colors } from 'chart.js'; 
import {MutatingDots} from 'react-loader-spinner'
import useMediaQuery from '@mui/material/useMediaQuery';

Chart.register(...registerables);
Chart.register(Colors);

const DashboardChart = () => {
    const [chartData, setChartData] = useState({})
    const [chartDataDeg, setChartDataDeg] = useState({})
    const [timeRange, setTimeRange] = useState('1m')
    
    const [timeRangeDeg, setTimeRangeDeg] = useState('1m')
    const [loaded, setLoaded] = useState(false)
    const [loadedDeg, setLoadedDeg] = useState(false)
    
  const matches = useMediaQuery("(min-width:600px)");
    const axiosPrivate = useAxiosPrivate()
    const fetchChartData = async (timeRange,isDeg) => {
        if(isDeg){
            axiosPrivate.post("/api/stats/getDatiPerGraficoDeg", {intervallo: timeRangeDeg})
            .then(res => {
                const validIndices = res.data
                .map((item, index) => item.numQuestionari > 0 ? index : -1)
                .filter(index => index !== -1);
              
              // Step 2: Use the indices to extract values
              const labels = validIndices.map(index => res.data[index].prestazione);
              const data = validIndices.map(index => res.data[index].numQuestionari);
              const colors = validIndices.map(index => res.data[index].colore.replace(" 1)", " 0.2)"));
              const borderColors = validIndices.map(index => res.data[index].colore);
                setChartDataDeg({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Numero di questionari compilati per dipartimento',
                            data: data,
                            backgroundColor: colors,
                            borderColor: borderColors,
                            borderWidth: 1,
                        },
                    ],
    
                })
                setLoadedDeg(true)
            })
            .catch(err => {
                console.error(err)
                setLoadedDeg(false)
            })
        }else {
            axiosPrivate.post("/api/stats/getDatiPerGrafico", {intervallo: timeRange})
            .then(res => {
                const validIndices = res.data
                .map((item, index) => item.numQuestionari > 0 ? index : -1)
                .filter(index => index !== -1);
              
              // Step 2: Use the indices to extract values
              const labels = validIndices.map(index => res.data[index].prestazione);
              const data = validIndices.map(index => res.data[index].numQuestionari);
              const colors = validIndices.map(index => res.data[index].colore.replace(" 1)", " 0.2)"));
              const borderColors = validIndices.map(index => res.data[index].colore);
                setChartData({
                    labels: labels,
                    datasets: [
                        {
                            label: 'Numero di questionari compilati per prestazione',
                            data: data,
                            backgroundColor: colors,
                            borderColor: borderColors,
                            borderWidth: 1,
                        },
                    ],
    
                })
                setLoaded(true)
            })
            .catch(err => {
                console.error(err)
                setLoaded(false)
            })
        }
        
    }

    useEffect(() => {
        fetchChartData(timeRange,false)
        fetchChartData(timeRangeDeg,true)
    }, [timeRange,timeRangeDeg])

    const handleTimeRangeChange = (tR) => {
        setTimeRange(tR)
    }
    const handleTimeRangeChangeDeg = (tR) => {
        setTimeRangeDeg(tR)
    }
    function generateColors(numColors) {
        const colors = [];
        
        for (let i = 0; i < numColors; i++) {
          const color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`;
          colors.push(color);
        }
        
        return colors;
      }
      
      function generateUniqueColor(prevColors) {
        let color = '';
      
        do {
          color = `rgba(${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, ${Math.floor(Math.random() * 256)}, 1)`;
        } while (prevColors.includes(color));
      
        return color;
      }

  return (
    <>
     <div className='chart-area'>
        <Box sx={{
            display: 'flex',
            flexDirection: matches ? 'row' : 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: '16px'
        }}>
            <div style={{justifySelf:'flex-start'}}>
                <Typography variant='h5' component="h5" >Numero di questionari compilati per prestazione (Da Voi a Noi)</Typography>
            </div>
            <ToggleButtonGroup value={timeRange} size="small" aria-label="small button group" exclusive>
                <ToggleButton value='1w' onClick={() => handleTimeRangeChange('1w')}>1 settimana</ToggleButton>
                <ToggleButton value='1m' onClick={() => handleTimeRangeChange('1m')}>1 mese</ToggleButton>
                <ToggleButton value='1y' onClick={() => handleTimeRangeChange('1y')}>1 anno</ToggleButton>
                <ToggleButton value='cy' onClick={() => handleTimeRangeChange('cy')}>Anno Corrente</ToggleButton>
            </ToggleButtonGroup>
          
        </Box>
        {!loaded && <div style={{height:350,display:'flex',alignItems:'center',justifyContent:'center'}}><MutatingDots 
                height="100"
                width="100"
                color="#4fa94d"
                secondaryColor= '#4fa94d'
                radius='12.5'
                ariaLabel="mutating-dots-loading"
                visible={true}
                /></div>}
        {loaded && 
        <div className='chart-container'><Bar data={chartData} options={{ responsive: true,maintainAspectRatio: false,  plugins: {
            colors: {
                enabled: true
              },
            legend: {
                display: false
            },}}} /></div>}
    </div>
        <div className='chart-area'>
        <Box sx={{
            display: 'flex',
            flexDirection: matches ? 'row' : 'column',
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: '16px'
        }}>
            <div style={{justifySelf:'flex-start'}}>
                <Typography variant='h5' component="h5" >Numero di questionari compilati per dipartimento (Degenti)</Typography>
            </div>
            <ToggleButtonGroup value={timeRangeDeg} size="small" aria-label="small button group" exclusive>
                <ToggleButton value='1w' onClick={() => handleTimeRangeChangeDeg('1w')}>1 settimana</ToggleButton>
                <ToggleButton value='1m' onClick={() => handleTimeRangeChangeDeg('1m')}>1 mese</ToggleButton>
                <ToggleButton value='1y' onClick={() => handleTimeRangeChangeDeg('1y')}>1 anno</ToggleButton>
                <ToggleButton value='cy' onClick={() => handleTimeRangeChangeDeg('cy')}>Anno Corrente</ToggleButton>
            </ToggleButtonGroup>
          
        </Box>
        {!loadedDeg && <div style={{height:350,display:'flex',alignItems:'center',justifyContent:'center'}}><MutatingDots 
                height="100"
                width="100"
                color="#4fa94d"
                secondaryColor= '#4fa94d'
                radius='12.5'
                ariaLabel="mutating-dots-loading"
                visible={true}
                /></div>}
        {loadedDeg && 
        <div className='chart-container'><Bar data={chartDataDeg} options={{ responsive: true,maintainAspectRatio: false,  plugins: {
            colors: {
                enabled: true
              },
            legend: {
                display: false
            },}}} /></div>}
    </div>
    </>
   
   
  )
}

export default DashboardChart